import React, {useState} from 'react';
import { Button, Divider, Layout, Text, Icon, Card } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions, Image, View, ImageBackground, TouchableOpacity } from 'react-native';
import * as RootNavigation from '../../../root.navigation.js';


const width = Dimensions.get('window').width;
const height = Dimensions.get('window').height;
const condWidth = Number(Dimensions.get('window').width) < 700 ? Dimensions.get('window').width : 700;

//
// const PlusIcon = (props) => (
//   <Icon {...props} name='plus-square-outline' />
// );
export const VEIKKScreen = () => {


  return (

    <ScrollView>
      <View style={styles.container} level='2' >
          <View style={{justifyContent:'space-between', alignItems:'center', paddingHorizontal: 20,  marginTop:35, marginBottom:10, marginHorizontal:10}}>
          <TouchableOpacity onPress={()=>{RootNavigation.navigate('Menu')}}>

            <Image source= {require('../../../assets/logo.png')} style={{width:100, height:100}} />
            </TouchableOpacity>            <Text status='primary' category='h2' style={{textAlign:'center', marginTop:20}}>قلم نوری</Text>
          </View>
          <View style={{flexDirection:'row', flex:1, paddingHorizontal:20}}>
            <View style={{flex:1, width: width*0.45, margin:4}}>
            <TouchableOpacity onPress={()=>{RootNavigation.navigate('a30')}}>
              <View style={{borderRadius:15, height: width*0.4*3/4, marginVertical:4}}>
                <ImageBackground source= {require('../../../assets/a30.jpg')}  resizeMode={"cover"} style={{...StyleSheet.absoluteFill, overflow: "hidden", borderRadius:20, borderWidth:2, borderColor:'#808080'}}>
                  <Text status='primary' category='h3' style={{marginTop:10, textAlign:'center', backgroundColor:'#ffffffaa'}}>مدل A30</Text>
                </ImageBackground>
              </View>
              </TouchableOpacity>
              <TouchableOpacity onPress={()=>{RootNavigation.navigate('a50')}}>
              <View style={{borderRadius:15, height: width*0.4*3/4, marginVertical:4}}>
                <ImageBackground source={require('../../../assets/a50.jpeg')}  resizeMode={"stretch"} style={{...StyleSheet.absoluteFill, overflow: "hidden", borderRadius:20, borderWidth:2, borderColor:'#808080'}}>
                  <Text status='primary' category='h3' style={{marginTop:10, textAlign:'center', backgroundColor:'#ffffffaa'}}>مدل A50</Text>
                </ImageBackground>
              </View>
              </TouchableOpacity>
            </View>
            <View style={{borderRadius:15, width: width*0.5, margin:4}}>
            <TouchableOpacity onPress={()=>{RootNavigation.navigate('v2200')}}>
              <View  style={{borderRadius:15, height: width*0.4*4/3, margin:4}}>
                <ImageBackground source={require('../../../assets/vk2200.jpg')}  resizeMode={"cover"} style={{...StyleSheet.absoluteFill, overflow: "hidden", borderRadius:20, borderWidth:2, borderColor:'#808080'}}>
                  <Text status='primary' category='h3' style={{marginTop:10, textAlign:'center', backgroundColor:'#ffffffaa'}}>مدل 2200Pro</Text>
                </ImageBackground>
              </View>
              </TouchableOpacity>
            </View>
          </View>
      </View>
      </ScrollView>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    alignItems:'center',
    justifyContent:'flex-start',
    width

  },
});
// <Image source= {require('../../../assets/new_invoice.png')} style={{width:width*0.7, height:width*0.7, marginVertical:25}} />
